import { NavLink } from "react-router-dom";
import { BarChart3, Briefcase, Building2, FileText, FolderKanban, LayoutDashboard, Settings, Users } from "lucide-react";

export const NAV = [
  { name: "Dashboard", path: "/dashboard", icon: LayoutDashboard },
  { name: "Contracts", path: "/contracts", icon: FileText },
  { name: "Contractors", path: "/contractors", icon: Users },
  { name: "Recruitment Companies", path: "/recruitment-companies", icon: Building2 },
  { name: "PTE Companies", path: "/pte-companies", icon: Briefcase },
  { name: "Templates", path: "/templates", icon: FolderKanban },
  { name: "Reports", path: "/reports", icon: BarChart3 },
  { name: "Admin", path: "/admin", icon: Settings },
];

export function SidebarNav({ onNavigate }) {
  return (
    <nav className="flex flex-col gap-1 px-3">
      {NAV.map(({ name, path, icon: Icon }) => (
        <NavLink key={path} to={path} onClick={onNavigate} data-testid={`nav-${path.slice(1)}`}
          className={({ isActive }) =>
            `flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors ${isActive ? "bg-blue-50 text-blue-700" : "text-slate-600 hover:bg-slate-100 hover:text-slate-900"}`}>
          <Icon className="h-4 w-4" />
          {name}
        </NavLink>
      ))}
    </nav>
  );
}

export function Brand() {
  return (
    <div className="flex items-center gap-2 px-6 h-16">
      <div className="h-8 w-8 rounded-md bg-blue-600 text-white flex items-center justify-center font-display font-extrabold text-sm">P</div>
      <div className="leading-tight">
        <div className="font-display font-bold text-slate-900 text-sm">PayMe Contracts</div>
        <div className="text-[11px] text-slate-400">Contractor management</div>
      </div>
    </div>
  );
}
